export function normalizeFolderName(value: string): string {
  return value.replace(/\s+/g, " ").trim();
}

export function isSameNormalizedFolderName(first: string, second: string) {
  return normalizeFolderName(first) === normalizeFolderName(second);
}
